import React from 'react';
import {Route, Routes} from 'react-router-dom';
import EmployeeReviewDashboard from "./EmployeeReviewDashboard";
import LifeWheel from "./LifeWheel";
import SPEAR from "./SPEAR";
import FeedbackSurvey from "./FeedbackSurvey";
import HistoricLifeWheel from "./HistoricLifeWheel";
import HistoricSPEAR from "./HistoricSPEAR";
import EmployeeReviewAdmin from "./EmployeeReviewAdmin";
import AdminSPEAR from "./AdminSPEAR";
import AdminBSC from "./AdminBSC";
import PrivateRoute from "../common/PrivateRoute";
import AdminLifeWheel from "./AdminLifeWheel";
import AdminFeedbackSurvey from "./AdminFeedbackSurvey";
import FeedbackSurveyReview from "./FeedbackSurveyReview";
import My360Submissions from "./My360Submissions";
import BalancedScorecardForm from "./BalancedScorecardForm";
import MyBSCSubmissions from "./MyBSCSubmissions";
import BSCPendingReview from "./BSCPendingReview";
import BSCManagerReview from "./BSCManagerReview";
import JobDescriptionList from "./JobDescriptionList";
import JobDescriptionForm from "./JobDescriptionForm";
import JobDescriptionView from "./JobDescriptionView";
import MyJobDescription from "./MyJobDescription";
import MyJobDescriptionForm from "./MyJobDescriptionForm";
import PEARReviewForm from "./PEARReviewForm";
import PEARReviewDashboard from "./PEARReviewDashboard";
import AdminPEARReview from "./AdminPEARReview";
import PEARSummary from "./PEARSummary";
import PEARManagerReview from "./PEARManagerReview";
import SPEARManagerReview from "./SPEARManagerReview";
import CEODashboard from "./CEODashboard";
import CEODepartmentView from "./CEODepartmentView";
import CEOEmployeeDetail from "./CEOEmployeeDetail";
import CastingTool from "./CastingTool";
import HistoricCastingTool from "./HistoricCastingTool";

const EmployeeReviewRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<EmployeeReviewDashboard />} />

      <Route path="/admin" element={<PrivateRoute element={<EmployeeReviewAdmin />} roles={['admin']} />} />
      <Route path="/admin/spear/:uuid" element={<PrivateRoute element={<AdminSPEAR />} roles={['admin']} />} />
      <Route path="/admin/life-wheel/:uuid" element={<PrivateRoute element={<AdminLifeWheel />} roles={['admin']} />} />
      <Route path="/admin/bsc/:uuid" element={<PrivateRoute element={<AdminBSC />} roles={['admin']} />} />
      <Route path="/admin/360/:uuid" element={<PrivateRoute element={<AdminFeedbackSurvey />} roles={['admin']} />} />

      <Route path="/life-wheel" element={<LifeWheel />} />
      <Route path="/life-wheel/historic" element={<HistoricLifeWheel />} />

      <Route path="/spear" element={<SPEAR />} />
      <Route path="/spear/historic" element={<HistoricSPEAR />} />
      <Route path="/spear/review/:id" element={<SPEARManagerReview />} />

      <Route path="/bsc" element={<BalancedScorecardForm />} />
      <Route path="/bsc/my-submissions" element={<MyBSCSubmissions />} />
      <Route path="/bsc/pending-review" element={<BSCPendingReview />} />
      <Route path="/bsc/review/:id" element={<BSCManagerReview />} />

      <Route path="/360-degree-survey" element={<FeedbackSurvey />} />
      <Route path="/360-degree-survey/feedback" element={<FeedbackSurveyReview />} />
      <Route path="/360-degree-survey/my-submissions" element={<My360Submissions />} />

      <Route path="/castingtool" element={<CastingTool />} />
      <Route path="/castingtool/historic" element={<HistoricCastingTool />} />

      {/* Job Description Routes - My JD accessible to all users */}
      <Route path="/job-descriptions/my" element={<MyJobDescription />} />
      <Route path="/job-descriptions/my/edit" element={<MyJobDescriptionForm />} />
      
      {/* Admin-only Job Description management */}
      <Route path="/job-descriptions" element={<PrivateRoute element={<JobDescriptionList />} roles={['admin']} />} />
      <Route path="/job-descriptions/new" element={<PrivateRoute element={<JobDescriptionForm />} roles={['admin']} />} />
      <Route path="/job-descriptions/:id" element={<PrivateRoute element={<JobDescriptionView />} roles={['admin']} />} />
      <Route path="/job-descriptions/:id/edit" element={<PrivateRoute element={<JobDescriptionForm isEdit />} roles={['admin']} />} />

      {/* PEAR Review Routes */}
      <Route path="/pear" element={<PEARReviewForm />} />
      <Route path="/pear/dashboard" element={<PEARReviewDashboard />} />
      <Route path="/pear/review/:id" element={<PEARManagerReview />} />
      <Route path="/pear/summary" element={<PrivateRoute element={<PEARSummary />} roles={['admin']} />} />
      <Route path="/admin/pear/:uuid" element={<PrivateRoute element={<AdminPEARReview />} roles={['admin']} />} />

      {/* CEO Dashboard Routes - All authenticated users (filtered by role) */}
      <Route path="/ceo-dashboard" element={<CEODashboard />} />
      <Route path="/ceo-dashboard/department/:department" element={<CEODepartmentView />} />
      <Route path="/ceo-dashboard/employee/:employeeId" element={<CEOEmployeeDetail />} />
    </Routes>
  );
}

export default EmployeeReviewRoutes;
